<div
  class="dashboard-page"
  [ngClass]="configurations?.pageClass"
  [class.disclaimer-page]="configurations?.['dashboard-name'] === 'Disclaimer'"
>
  <h2
    class="dashboard-title"
    [class.mine-level-summary-title]="configurations?.['dashboard-name'] === 'Mine Level Summary'"
    *ngIf="configurations?.['dashboard-name']"
  >
    {{ configurations['dashboard-name'] }}
  </h2>

  @if(!!configurations?.filters) {
  @if(useV2Filter) {
  <app-global-filter-v2 [config]="configurations?.filters"></app-global-filter-v2>
  }
  @else {
  <app-global-filter [config]="configurations?.filters"></app-global-filter>
  }
  }

  <div class="dashboard-content" [@fadeIn]="configurations">
    @for (item of configurations?.pageContent; track $index) {
    <div class="row">
      @if(item?.title) {
      <h4 class="title">{{ item?.title }}</h4>
      }

      @for (column of item?.columns; track $index) {
      <div class="col {{ column?.class }}" [class.tco-panel-column]="column?.widgetId === 'repower-tco-header'">
        <!-- If column is a widget -->
        @if (column?.type) {
        <app-widget-renderer [charts]="column"></app-widget-renderer>
        }

        <!-- Nested rows inside column -->
        @if (column?.rows?.length > 0) {
        @for (nestedItem of column.rows; track $index) {

        <!-- If nestedItem is a widget (has type) -->
        @if(nestedItem?.type) {
        <div class="col {{ nestedItem?.class }}">
          <app-widget-renderer [charts]="nestedItem"></app-widget-renderer>
        </div>
        }

        <!-- If nestedItem is a row (has columns) -->
        @if(nestedItem?.columns?.length > 0) {
        <div class="row" [class.tco-panel-content-row]="column?.widgetId === 'repower-tco-header'">
          @if(nestedItem?.title) {
          <h4 class="title">{{ nestedItem?.title }}</h4>
          }
          @for (nestedCol of nestedItem.columns; track $index) {
          <div class="col {{ nestedCol?.class }}" [class.tco-notes-slot]="column?.widgetId === 'repower-tco-header' && nestedCol?.type === 'notes'">
            <app-widget-renderer [charts]="nestedCol"></app-widget-renderer>
          </div>
          }
        </div>
        }
        }
        }
      </div>
      }
    </div>
    }
  </div>
</div>
